module.exports = {
    demo: false,
    brand: 'MatthewsLiquor', // Footer brand
    appName: 'MatthewsLiquor', // App Name
    showCredits: true, // Show credits in login page
    url: 'https://chathub.matthewsliquor.com.au', //https://chathub.matthewsliquor.com.au
}